var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            title: "充值",
            "class-name": "vertical-center-modal my-modal",
            "mask-closable": false,
            loading: _vm.submitLoading,
            width: "660",
            "footer-hide": true
          },
          on: { "on-cancel": _vm.cancel },
          model: {
            value: _vm.modalShow,
            callback: function($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow"
          }
        },
        [
          _c("div", { staticClass: "pay-dialog-body" }, [
            _c("div", { staticClass: "pay-user-info" }, [
              _vm._v("账户余额 "),
              _c("b", [_vm._v(_vm._s(_vm.user.amount || 0))]),
              _vm._v(" 焕新币")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "money-list" },
              [
                _vm._l(_vm.moneyList, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "money-item",
                      on: {
                        click: function($event) {
                          return _vm.selectMoney(item)
                        }
                      }
                    },
                    [
                      item.selected
                        ? _c("img", {
                            staticClass: "selected-logo",
                            attrs: {
                              src: require("@/assets/img/live/selected.png")
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", [
                        _c("img", {
                          staticClass: "hxb-logo",
                          attrs: { src: require("@/assets/img/live/hxb.png") }
                        })
                      ]),
                      _vm._v(" "),
                      _c("p", [_c("b", [_vm._v(_vm._s(item.label))])]),
                      _vm._v(" "),
                      _c("p", { staticClass: "bottom" }, [
                        _vm._v(_vm._s(item.label))
                      ])
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "money-item",
                    on: {
                      click: function($event) {
                        return _vm.selectMoney(null)
                      }
                    }
                  },
                  [
                    _vm.enterMoney != ""
                      ? _c("img", {
                          staticClass: "selected-logo",
                          attrs: {
                            src: require("@/assets/img/live/selected.png")
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p", [
                      _c("img", {
                        staticClass: "hxb-logo",
                        attrs: { src: require("@/assets/img/live/hxb.png") }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticStyle: { margin: "0 0 2px 0!important" } },
                      [
                        _c("Input", {
                          staticStyle: {
                            "font-size": "18px",
                            "font-weight": "bold"
                          },
                          attrs: { placeholder: "输入金额", maxlength: "8" },
                          on: { "on-change": _vm.changeEnterMoney },
                          model: {
                            value: _vm.enterMoney,
                            callback: function($$v) {
                              _vm.enterMoney = $$v
                            },
                            expression: "enterMoney"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "bottom",
                        staticStyle: { border: "none" }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.enterMoney == "" ? "1" : _vm.enterMoney) +
                            "元"
                        )
                      ]
                    )
                  ]
                )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "pay-user-info",
                staticStyle: { "margin-top": "20px" }
              },
              [_vm._v("支付方式")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "paytype-list" },
              _vm._l(_vm.payTypeList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "paytype-item",
                    on: {
                      click: function($event) {
                        return _vm.selectPaytype(item)
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "paytype-logo",
                      attrs: { src: item.img, alt: item.name }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.name))]),
                    _vm._v(" "),
                    item.selected
                      ? _c("img", {
                          staticClass: "selected-logo",
                          attrs: {
                            src: require("@/assets/img/live/selected.png")
                          }
                        })
                      : _vm._e()
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "pay-qrbox" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    "align-items": "center",
                    "text-align": "center"
                  }
                },
                [
                  _c("img", {
                    staticClass: "paytype-logo",
                    staticStyle: { display: "inline", "margin-top": "0px" },
                    attrs: { src: _vm.txtPayType.img, alt: _vm.txtPayType.name }
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n                        请使用" +
                        _vm._s(_vm.txtPayType.scanName) +
                        "，支付"
                    ),
                    _c("span", { staticClass: "money" }, [
                      _vm._v("￥" + _vm._s(_vm.txtPayMoney))
                    ]),
                    _vm._v("元\n                    ")
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.payButtonShow
                ? _c(
                    "div",
                    { staticClass: "pay-button" },
                    [
                      _c(
                        "Button",
                        {
                          attrs: {
                            type: "primary",
                            loading: _vm.submitLoading
                          },
                          on: { click: _vm.payNow }
                        },
                        [_vm._v("立即支付")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.payButtonShow,
                      expression: "!payButtonShow"
                    }
                  ]
                },
                [_c("div", { ref: "qrCodeUrl", staticClass: "qrcode" })]
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticStyle: { margin: "10px 0 0 0" } },
                [
                  _c(
                    "CheckboxGroup",
                    {
                      model: {
                        value: _vm.checkboxVal,
                        callback: function($$v) {
                          _vm.checkboxVal = $$v
                        },
                        expression: "checkboxVal"
                      }
                    },
                    [
                      _c("Checkbox", { attrs: { label: "1" } }, [
                        _vm._v("  同意充值服务协议")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68b11216", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68b11216","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChongZhiModal.vue
// module id = null
// module chunks = 